/* Carole — account panel + liked products
   Powers the floating launcher (sections/carole-account.liquid) and the heart
   buttons rendered server-side in snippets/product-card.liquid and the product page.

   Works signed in or signed out. Liked products and style preferences live in
   localStorage, so they need no account; orders and the name come from Liquid. */
(function () {
  'use strict';

  var LIKED = 'carole_liked';
  var CACHE = 'carole_liked_cache_v1';
  var MAX = 200;

  /* ---------------------------------------------------------------
     i18n
     --------------------------------------------------------------- */
  var STRINGS = {
    en: {
      open: 'My Carole',
      close: 'Close',
      hi: 'Hi',
      hello: 'Your Carole',
      sub_in: 'Everything in one place.',
      sub_out: 'Your style, your saves — no account needed.',

      foryou: 'For You',
      foryou_sub: 'Picked from your answers',

      style: 'My style',
      style_edit: 'Edit',
      style_none: 'Take the 6-question quiz and we will build a feed around you.',
      style_cta: 'Start the quiz',

      liked: 'Liked',
      liked_none: 'Nothing saved yet. Tap the heart on anything you like.',
      liked_all: 'See all',
      remove: 'Remove',
      sold: 'Sold',

      orders: 'Orders',
      orders_none: 'Sign in to follow your orders.',
      orders_empty: 'No orders yet.',
      order_view: 'View',

      account: 'Account',
      acct_profile: 'My account',
      acct_addresses: 'Addresses',
      acct_logout: 'Sign out',
      acct_login: 'Sign in',
      acct_register: 'Create an account',
      acct_hint: 'Sign in to see your orders and keep your details.',

      help: 'Help',
      help_chat: 'Chat with us',
      help_faq: 'FAQ',
      help_contact: 'Contact us',
      help_shipping: 'Shipping & returns',

      save: 'Save',
      saved: 'Saved'
    },
    fr: {
      open: 'Mon Carole',
      close: 'Fermer',
      hi: 'Salut',
      hello: 'Mon Carole',
      sub_in: 'Tout au même endroit.',
      sub_out: 'Ton style, tes coups de cœur — sans compte.',

      foryou: 'Pour toi',
      foryou_sub: 'Choisi selon tes réponses',

      style: 'Mon style',
      style_edit: 'Modifier',
      style_none: 'Fais le quiz de 6 questions et on te bâtit un fil sur mesure.',
      style_cta: 'Commencer le quiz',

      liked: 'Coups de cœur',
      liked_none: 'Rien d’enregistré. Touche le cœur sur ce que tu aimes.',
      liked_all: 'Voir tout',
      remove: 'Retirer',
      sold: 'Vendu',

      orders: 'Commandes',
      orders_none: 'Connecte-toi pour suivre tes commandes.',
      orders_empty: 'Aucune commande.',
      order_view: 'Voir',

      account: 'Compte',
      acct_profile: 'Mon compte',
      acct_addresses: 'Adresses',
      acct_logout: 'Déconnexion',
      acct_login: 'Connexion',
      acct_register: 'Créer un compte',
      acct_hint: 'Connecte-toi pour voir tes commandes et garder tes infos.',

      help: 'Aide',
      help_chat: 'Clavarder avec nous',
      help_faq: 'FAQ',
      help_contact: 'Nous joindre',
      help_shipping: 'Livraison & retours',

      save: 'Garder',
      saved: 'Gardé'
    }
  };

  function lang() {
    var l = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
    return l.indexOf('fr') === 0 ? 'fr' : 'en';
  }
  function t(k) {
    var L = STRINGS[lang()] || STRINGS.en;
    return L[k] != null ? L[k] : (STRINGS.en[k] || k);
  }
  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.replace(/\/$/, '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var v = (cents || 0) / 100;
    return lang() === 'fr' ? v.toFixed(2).replace('.', ',') + ' $' : '$' + v.toFixed(2);
  }

  /* ---------------------------------------------------------------
     Liked products — handles only; details are fetched on demand
     --------------------------------------------------------------- */
  function readLiked() {
    try {
      var a = JSON.parse(localStorage.getItem(LIKED) || '[]');
      return Array.isArray(a) ? a.filter(function (x) { return x && x.h; }) : [];
    } catch (e) { return []; }
  }
  function writeLiked(a) {
    try { localStorage.setItem(LIKED, JSON.stringify(a.slice(0, MAX))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('carole:liked:change', { detail: { count: a.length } }));
  }
  function isLiked(handle) {
    return readLiked().some(function (x) { return x.h === handle; });
  }
  function toggleLike(handle) {
    var a = readLiked();
    var i = -1;
    for (var k = 0; k < a.length; k++) { if (a[k].h === handle) { i = k; break; } }
    if (i === -1) a.unshift({ h: handle, ts: Date.now() });
    else a.splice(i, 1);
    writeLiked(a);
    return i === -1;
  }

  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CACHE) || '{}') || {}; } catch (e) { cache = {}; }
  function saveCache() {
    try { sessionStorage.setItem(CACHE, JSON.stringify(cache)); } catch (e) {}
  }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root() + '/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
        var size = '';
        (p.options || []).forEach(function (o, idx) {
          var name = typeof o === 'string' ? o : o.name;
          if (name === 'Size') size = (v.options && v.options[idx]) || '';
        });
        var d = {
          h: p.handle,
          t: p.title,
          ty: p.type,
          sz: size,
          pr: v.price || p.price,
          cp: v.compare_at_price || 0,
          im: p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '',
          av: !!p.available
        };
        cache[handle] = d;
        saveCache();
        return d;
      })
      .catch(function () { return null; });
  }

  /* ---------------------------------------------------------------
     Product page save button.
     Cards render their heart in Liquid (they get replaced wholesale by
     filtering and load-more), but the product page is stable, so the inline
     save button is injected here rather than editing the 53 KB product
     section. Idempotent, and re-run by the observer below.
     --------------------------------------------------------------- */
  var HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.4s-6.8-4.2-8.5-8.2A4.75 4.75 0 0 1 12 7a4.75 4.75 0 0 1 8.5 5.2c-1.7 4-8.5 8.2-8.5 8.2z"/></svg>';

  function productHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function injectSave() {
    var handle = productHandle();
    if (!handle) return;
    var slots = document.querySelectorAll('.product-form__quantity__add__buttons');
    if (!slots.length) {
      // fall back to sitting beside the add-to-cart button itself
      slots = [];
      document.querySelectorAll('.product-form__submit').forEach(function (b) {
        if (b.parentNode) slots.push(b.parentNode);
      });
    }
    Array.prototype.forEach.call(slots, function (wrap) {
      // quick-add renders the product section inside a modal; the card behind
      // it already carries a heart, so skip those
      if (wrap.closest('[id^="shopify-section-quickadd"], .quickview, quick-add-modal, .quick-add-modal')) return;
      if (wrap.querySelector('[data-carole-like]')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ca-heart ca-heart--inline';
      b.setAttribute('data-carole-like', handle);
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', t('save'));
      b.innerHTML = HEART_SVG + '<span data-carole-like-label>' + t('save') + '</span>';
      wrap.appendChild(b);
    });
  }

  /* ---------------------------------------------------------------
     Heart buttons — rendered in Liquid, hydrated + delegated here
     --------------------------------------------------------------- */
  function hydrate(scope) {
    var liked = {};
    readLiked().forEach(function (x) { liked[x.h] = true; });
    (scope || document).querySelectorAll('[data-carole-like]').forEach(function (btn) {
      var on = !!liked[btn.getAttribute('data-carole-like')];
      btn.classList.toggle('is-liked', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? t('saved') : t('save'));
      var label = btn.querySelector('[data-carole-like-label]');
      if (label) label.textContent = on ? t('saved') : t('save');
    });
    var badges = document.querySelectorAll('[data-carole-liked-count]');
    var n = readLiked().length;
    badges.forEach(function (b) {
      b.textContent = n;
      b.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carole-like]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-carole-like');
    if (!handle) return;
    var nowOn = toggleLike(handle);
    btn.classList.toggle('is-liked', nowOn);
    if (nowOn) {
      btn.classList.add('is-pop');
      setTimeout(function () { btn.classList.remove('is-pop'); }, 320);
      fetchProduct(handle);
    }
    hydrate();
  });

  // Collection filtering, load-more and predictive search all replace card
  // markup wholesale, so re-apply saved state whenever the DOM changes.
  var pending = null;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; injectSave(); hydrate(); }, 120);
  });

  document.addEventListener('carole:liked:change', function () { hydrate(); });

  window.CaroleAccount = {
    t: t, root: root, esc: esc, money: money, lang: lang,
    readLiked: readLiked, writeLiked: writeLiked, isLiked: isLiked,
    toggleLike: toggleLike, fetchProduct: fetchProduct, hydrate: hydrate,
    injectSave: injectSave,
    startObserver: function () {
      try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    }
  };

  function boot() {
    injectSave();
    hydrate();
    window.CaroleAccount.startObserver();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
